import React from 'react';
import { Helmet } from 'react-helmet';

// Injecting global styles to override values but ONLY if this
// component exists in the DOM. Othwerwise CSS props would leak out
// to other parts of the application, hence regular import isn't
// possible.

const Helmets = () => (
  <Helmet>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style type="text/css">
      {`.c-notifications-basic-layout {
            min-width: auto;

            background: linear-gradient(0deg, #eaeaea 0, #fffffe 50%);
        }

        @media screen and (prefers-color-scheme: dark) {
            .c-notifications-basic-layout {
                background: #222222 !important;
            }
        }
      
        .c-notifications-basic-layout > * {
            max-width: 632px;
            width: 100%;
            margin: auto;
        }
        
        #app {
            padding-bottom: 0 !important;
        }`}
    </style>
  </Helmet>
);

export default Helmets;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Flagship/components/Helmets.jsx